import { faMoneyBill1 } from "@fortawesome/free-regular-svg-icons";
import { ChoicePicker, ChoicePickerOption } from "../ChoicePicker";
import { useTranslation } from "react-i18next";
import { SellingStrategyId } from "../../../Business/dto/BriefJAM";


interface SellingStrategyPickerProps {
    setSelectedSellingStrategy: (data: any) => void;
    availableSellingStrategies?: SellingStrategyId[];
    required?: boolean;
    value: SellingStrategyOption | undefined;
}

export interface SellingStrategyOption extends ChoicePickerOption {
    id: SellingStrategyId;
    name: string
}

export const SellingStrategyPicker = (props: SellingStrategyPickerProps) => {
    const { t } = useTranslation();
    const data: SellingStrategyOption[] = [
        {id: "discount", name: t("txt_method_discount")},
        {id: "costgrp-campaign", name: t("txt_method_grpcc")},
        {id: "costgrp-spot", name: t("txt_method_grpcs")},
        {id: "spotcount", name: t("txt_spot_count")}
    ]

    return (
        <ChoicePicker
            setSelectedData={props.setSelectedSellingStrategy}
            placeholder={t("txt_selling_strategy")}
            data={props.availableSellingStrategies ? data.filter((option) => props.availableSellingStrategies?.includes(option.id)) : data}
            multiple={false}
            icon={faMoneyBill1}
            required={props.required}
            controlId="sellingStrategyPicker"
            value={props.value ? [props.value] : []}
        />
);
}